<template>
    <!--Waiting List Enroll Info First Screen-->
    <div class="enroll-info-screen">
        <div class="enroll-wrapper">
            <p>{{ $t("waitingListEnroll.firstScreenP") }}</p>
            <p>{{ $t("waitingListEnroll.firstScreenP2") }}</p>
            <div class="list-wrapper">
                <p v-html="$t('waitingListEnroll.firstScreenP3')"></p>
                <ul>
                    <li v-html="$t('waitingListEnroll.firstScreenP3Li1')"></li>
                    <li v-html="$t('waitingListEnroll.firstScreenP3Li2')"></li>
                </ul>
            </div>
            <p v-html="$t('waitingListEnroll.firstScreenP4')"></p>
            <p v-html="$t('waitingListEnroll.firstScreenP5')"></p>
            <p>{{ $t("waitingListEnroll.firstScreenP6") }}</p>
            <div class="trial-expired-wrap" v-if="adminDetails.web_trial_expired">
                <p class="trial-expired">
                    {{ $t("waitingListEnroll.firstScreenP7") }} Go to <router-link class="main-text-link"
                        :to="{ path: '/app/subscription-payments' }">
                        Subscription & Payments.
                    </router-link>
                </p>

            </div>
        </div>
        <!--Waiting List Enroll Read More Button-->
        <div class="enroll-btn">
            <button @click="changeScreen('secound-screen')" class="primary-btn extra-small mobile"
                :class="{ 'disabled-button': adminDetails.web_trial_expired }">
                {{ $t("general.continue") }}
            </button>
        </div>
    </div>
</template>

<script>
import store from "../../../../services/vuex";

export default {
    data() {
        return {};
    },
    computed: {
        adminDetails: {
            get: function () {
                return this.$store.state.adminDetails;
            },
            set: function (value) {
                this.$store.commit("setAdminDetails", value);
            },
        },
    },
    mounted() {
        this.checkEnrollmentIsComplete()
    },
    methods: {
        changeScreen(screen) {
            this.$emit('change-screen', screen);
        },
        checkEnrollmentIsComplete() {
            if (this.adminDetails) {
                if (this.adminDetails.waiting_list_subscription_active && !this.adminDetails.waiting_list_enrollment_finished) {
                    // Condition: Active and not finished
                    this.changeScreen('enroll-step-three');
                } else if (!this.adminDetails.waiting_list_subscription_active && !this.adminDetails.waiting_list_enrollment_finished) {
                    // Condition: Not active and not finished
                    this.changeScreen('first-screen');
                }
            }
        }

    },
    components: {}
};
</script>
